import * as machinemotion from "../api/machinemotion";
import widgets from "../legacy/widgets";
import { Application } from "./Application";
import { ApplicationTypes } from "./constants/ApplicationTypes";

/**
 * GeneratedMachineAppApplication are created by the InjectableMachineAppApplications.
 * They override the functionality of a regular Application in order to avoid saving entirely.
 */
export class GeneratedMachineAppApplication extends Application {
  constructor(pLibrary) {
    super(pLibrary, ApplicationTypes.GeneratedMachineApp, false, false);
    this.mLibrary = pLibrary;
  }
}

GeneratedMachineAppApplication.prototype.play = function(pRunTimeConfiguration, callbackPlay) {
  // WARNING: as of #2044, this 'play' function is entirely superseded in simulation, by the vention_assembler's machinelogic.js; the implementation here is not reused.

  if (!this.canPlayRobotApp() && this.hasRobotSimulateInstruction()) {
    widgets.messageBox('Your robot is not connected. Go to the configuration pane to connect your robot', 'error');
    return;
  }

  if(!this.isActive()) {
    this.onBeginActive();
    machinemotion.playTemporary(this.mName, this.toJson(), pRunTimeConfiguration, (pState) => {
      this.setState(pState);
      callbackPlay(pState);
    });
  }
};

GeneratedMachineAppApplication.prototype.deploy = function(pOnComplete) { if(pOnComplete) pOnComplete(this.toJson()); };

GeneratedMachineAppApplication.fromJson = function(pLibrary, pJson) {
  const generatedApplication = new GeneratedMachineAppApplication(pLibrary);
  Application._fromJsonInternal(generatedApplication, pLibrary, pJson);
  return generatedApplication;
};
